import React from 'react';

interface FooterProps {
  version?: string;
  year?: number;
}

const Footer: React.FC<FooterProps> = ({ version = '1.0.0', year = new Date().getFullYear() }) => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="container footer-container">
        <div className="footer-info">
          <p>
            <span className="app-name">MultiscalePCP</span> v{version} &copy; {year}
          </p>
          <p className="footer-note">
            A visualization tool for exploring multidimensional data using parallel coordinates
          </p>
        </div>

        <div className="keyboard-shortcuts" aria-label="Keyboard shortcuts">
          <details>
            <summary>Keyboard Shortcuts</summary>
            <ul className="shortcuts-list">
              <li>
                <kbd>Esc</kbd> - Reset selection
              </li>
              <li>
                <kbd>Space</kbd> - Toggle labels
              </li>
              <li>
                <kbd>L</kbd> - Toggle label visibility
              </li>
              <li>
                <kbd>R</kbd> - Reset view
              </li>
              <li>
                <kbd>↑</kbd> - Navigate up
              </li>
              <li>
                <kbd>↓</kbd> - Navigate down
              </li>
            </ul>
          </details>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
